import GeneratedTwoFactorServiceApi from "./generated/GeneratedTwoFactorServiceApi"

class TwoFactorServiceApi extends GeneratedTwoFactorServiceApi {

}

export const twoFactorServiceApi = new TwoFactorServiceApi()
